<template>
    <div class="exec-kpi-card">
        <div class="kpi-icon-wrapper" :class="iconBgClass">
            <i :class="['kpi-icon', iconClass, iconColorClass]"></i>
        </div>
        <div class="kpi-info">
            <span class="kpi-value">{{ value }}</span>
            <span class="kpi-title">{{ title }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    title: { type: String, required: true },
    value: { type: [Number, String], required: true },
    type: { type: String, default: 'warning' } // 'warning' | 'danger'
});

const iconClass = computed(() => {
    return props.type === 'danger' ? 'pi pi-times-circle' : 'pi pi-exclamation-triangle';
});

const iconColorClass = computed(() => {
    return props.type === 'danger' ? 'icon-red' : 'icon-yellow';
});

const iconBgClass = computed(() => {
    return props.type === 'danger' ? 'bg-red' : 'bg-yellow';
});
</script>

<style scoped>
.exec-kpi-card {
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 1.25rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    transition: border-color 0.2s;
    height: 100%;
}

.exec-kpi-card:hover {
    border-color: #444444;
}

.kpi-icon-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.kpi-icon {
    font-size: 1.3rem;
}

/* Color Variants */
.icon-yellow { color: #eab308; }
.icon-red { color: #ef4444; }
.bg-yellow { background-color: rgba(234, 179, 8, 0.15); }
.bg-red { background-color: rgba(239, 68, 68, 0.15); }

.kpi-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.kpi-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #e6edf3;
    line-height: 1.1;
    margin-bottom: 0.15rem;
}

.kpi-title {
    font-size: 0.85rem;
    color: #8b949e;
    font-weight: 500;
}
</style>
